var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelephone = function SvgTelephone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.813 13.506c-1.525.025-3.025-.322-4.5-1.04a14.785 14.785 0 0 1-3.975-2.832A14.318 14.318 0 0 1 1.507 5.66C.794 4.178.437 2.669.437 1.13c0-.112.01-.243.03-.393C.484.588.506.463.53.362h4.05l.75 3.581-2.156 2.063a14.09 14.09 0 0 0 2.063 2.7 12.06 12.06 0 0 0 2.7 2.1l2.138-2.175 3.487.806v3.975c-.088.038-.21.063-.366.075a4.954 4.954 0 0 1-.384.019ZM2.537 4.769 3.906 3.53l-.412-1.857h-1.65a5.008 5.008 0 0 0 .178 1.604c.144.506.316 1.003.516 1.49Zm6.638 6.675c.45.2.962.362 1.537.487a8.35 8.35 0 0 0 1.537.206v-1.706l-1.743-.375-1.331 1.388Z",
    fill: "#000"
  })));
};
export default SvgTelephone;